/* eslint-disable @typescript-eslint/no-explicit-any */
import { TextEditor } from '@/components/Ui';

import { Button, TextField } from '@/components/Common';
import { TextfieldType } from '@/components/Common/TextField/TextField.types';
import { Tabs } from '@/components/Ui';
import { GeneratedQuiz } from '../GeneratedQuiz/GeneratedQuiz';
import { Divider } from 'primereact/divider';
import { useCallback, useState, useEffect } from 'react';
import { SectionType } from '@/api/gql/graphql';
import { createMenuItem } from '@/components/Common/DropdownMenu/MenuDropdown.utils';
import Highlights from '../../module/Highlights';
import { useHighlights } from '../../module/highlights.hook';
import HighlightsForm from '../../module/HighlightsForm';

// import EvaluationFinal from '../EvaluationFinal/EvaluationFinal';
import { useGeneratedModule } from './generatedModule.hook';

interface GeneratedModuleProps {
  moduleId?: string;
}

export const GeneratedModule = ({ moduleId }: GeneratedModuleProps) => {
  const {
    modules,
    showToast,
    currentHighlights,
    setGeneratedHighlightsId,
    generatedHighlightsId,
    content,
    setContent,
    title,
    setTitle,
    onSubmitGeneratedContent,
  } = useGeneratedModule();

  const { openHighlightModal } = useHighlights();

  const [searchHighlights, setSearchHighlights] = useState('');
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (moduleId && modules?.length > 0) {
      const module = modules?.find(
        (module: any) => module.section._id === moduleId,
      );
      if (module) {
        setTitle(module.section.title);
        const mainContent = module.section.content[0];
        if (mainContent) {
          setContent(mainContent.html);
        }
      }
    }
  }, [moduleId, modules, setContent, setTitle]);

  const menuItems = useCallback(
    (id: string) => {
      const handleCopyLink = () => {
        navigator.clipboard.writeText(`#${id}`).then(
          () => {
            showToast('Lien copié', 'success', { autoClose: 5000 });
          },
          () => {
            showToast('Erreur lors de la copie du lien', 'error', {
              autoClose: 5000,
            });
          },
        );
      };

      const handleEditHighlight = () => {
        openHighlightModal();
        setGeneratedHighlightsId(id);
      };

      return [
        createMenuItem('Copier lien', '', handleCopyLink),
        createMenuItem('Modifier', '', handleEditHighlight),
      ];
    },
    [openHighlightModal, setGeneratedHighlightsId, showToast],
  );

  const handleContentChange = (newContent: string) => {
    setContent(newContent);
  };

  const handleTitleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setTitle(e.target.value);
  };

  return (
    <>
      <div className="overflow-x-auto max-w-[calc(100%-40px)]">
        <Tabs
          activeIndex={activeTab}
          setActiveIndex={setActiveTab}
          tabs={[
            {
              id: 1,
              title: 'Leçon',
              type: SectionType.Main,
            },
            {
              id: 2,
              title: 'Quizz',
              type: SectionType.Main,
            },
          ]}
          tabsStyle="flex whitespace-nowrap"
        />
      </div>
      {activeTab === 0 ? (
        <div className="">
          <TextField
            placeholder="Titre du module"
            type={TextfieldType.INPUT}
            textFieldType={TextfieldType.INPUT}
            name="title"
            value={title}
            handleChange={handleTitleChange}
            errorStyle="text-red-500 text-xs text-center !font-normal ml-[70px]"
            className="!bg-eerieBlack w-full md:w-[283px] h-[55px] !border-[1.165px] !border-onyx mt-9 mb-5"
          />
          <div className="grid grid-cols-1 lg:grid-cols-[minmax(600px,_1fr)_auto_1fr] gap-4 items-start">
            <div className="relative flex flex-col gap-4">
              <TextEditor
                value={content}
                backgroundColor="#000"
                onChange={handleContentChange}
              />
              <div className="flex justify-between gap-2 mb-2">
                <Button
                  onClick={() => {
                    if (moduleId) {
                      onSubmitGeneratedContent(
                        {
                          content,
                          title,
                        },
                        moduleId,
                      );
                    } else {
                      showToast('Module ID manquant', 'error');
                    }
                  }}
                  title={'Enregistrer brouillon'}
                  className="bg-white text-black"
                  type="button"
                />
              </div>
            </div>
            <Divider
              layout="vertical"
              className="bg-gunmetal w-[1px] h-full mx-4"
            />

            <Highlights
              highlights={moduleId ? currentHighlights(moduleId) : []}
              searchHighlights={searchHighlights}
              setSearchHighlights={setSearchHighlights}
              menuItems={menuItems}
              openHighlightModal={openHighlightModal}
              className="mt-0"
            />
          </div>
          <HighlightsForm
            moduleId={moduleId}
            selectedHighlight={
              moduleId
                ? currentHighlights(moduleId).find(
                    (h) => h._id === generatedHighlightsId,
                  )
                : null
            }
          />
        </div>
      ) : activeTab === 1 ? (
        <GeneratedQuiz moduleId={moduleId || ''} />
      ) : null}
    </>
  );
};
